export enum AccountTypeEnum {
    EMPLOYER = 'employer',
    STAFFER = 'staffer'

}
